import type { BISettings } from './../../ricos-common/RicosTypes.js';
import type { BICallbacks } from './../../ricos-types/index.js';

import type { RicosBILogger } from './ricos-bi-logger.js';

export type BiStrategyResult = {
  helpers: BICallbacks;
  biLogger: RicosBILogger;
};

export type CreateBiHelpersParams = {
  appDefId: string;
  metaSiteId: string;
  biSettings: BISettings;
  wixRicosVersion: string;
  ricosVersion: string;
};

/**
 * Creates BI helpers by lazy loading the biStrategy module.
 * Only loads the BI code when both appDefId/metaSiteId and biSettings are provided.
 */
export const createBiHelpers = async ({
  appDefId,
  metaSiteId,
  biSettings,
  wixRicosVersion,
  ricosVersion,
}: CreateBiHelpersParams): Promise<BiStrategyResult> => {
  const { biStrategy } = await import('./bi-strategy.js');
  return biStrategy(appDefId, metaSiteId, wixRicosVersion, ricosVersion, biSettings);
};

// Re-export biStrategy for direct usage (non-lazy)
export { biStrategy } from './bi-strategy.js';
export { RicosBILogger } from './ricos-bi-logger.js';
